import ActiveRecord from '@mysidewalk/active-record';
import SessionManagerRecordSource from './SessionManagerRecordSource.js';
class SessionManagerRecord extends ActiveRecord {
}
SessionManagerRecord.$AR = {
    url: '',
    SourceClass: SessionManagerRecordSource,
};
export default SessionManagerRecord;
export { SessionManagerRecordSource };
